import { createContext, useContext } from 'react'

type Session = { user: any } | null

export type ProfileContextValue = {
  session: Session
  profile: any
  orgUsers: any[]
  refreshProfile: () => Promise<void>
}

export const ProfileContext = createContext<ProfileContextValue>({
  session: null,
  profile: null,
  orgUsers: [],
  refreshProfile: async () => {},
})

export function useProfile(): ProfileContextValue {
  return useContext(ProfileContext)
}
